import { NgModule } from '@angular/core';
import { AuthForgotModule } from './forgot/auth-forgot.module';
import { AuthLoginModule } from './login/auth-login.module';
import { AuthResetModule } from './reset/auth-reset.module';
import { AuthValidateModule } from './validate/auth-validate.module';

@NgModule({
  imports: [AuthForgotModule, AuthLoginModule, AuthResetModule, AuthValidateModule],
})
export class AuthRoutesModule {}
